<template>
  <!-- <div style="height: 2rem">HEADER</div> -->
  <navigation-bar
    :imageName="imageName"
    :missionGroupName="missionGroupName"
    :isEditable="isEditable"
    :editorEnabled="editorEnabled" 
    :userName="userName"
    :navBarActive="navBarActive"
    :layers="layers"
    :drawingsOn="drawingsOn"
    :neuralOn="neuralOn"
    :userId="userId"
    @save-markup="saveOnButton"
    @editor-is-enabled="turnEditorOn"
  />  
  <div class="map-container">
    <map-context-menu></map-context-menu>
    <image-area />
    <div class="left-panel">
      <div class="left-panel-even-spaced">
        <drawing-settings v-if="drawingsOn"/>
        <keep-alive>
          <object-info v-if="!drawingsOn" :layers="layers" :tags="tags" />
        </keep-alive>
      </div>
      <div class="left-panel-even-spaced scroll-list">
        <LayersArea
          :extraLayers="extraLayers"
          :hasExtraLayers="hasExtraLayers"
          @load-extra-layers="getExtraLayers"
          @hide-extra-layers="hideExtraLayers"
          :extraLayersLoaded="extraLayersLoaded"
          :extended="isSuperviser"
        />
      </div>
      <div class="left-panel-min-spaced">
        <useful-tools :roles="roles"/>
      </div>
    </div>
  </div>
  <message-presenter />
  <Modal :isShown="modalIsShown" :messasge="modalMessage" @close-win="closeModal"/>
  <Footer
    :imageCount="imageCount"
    :number="number"
    :jumpStep="jumpStep"
    @go-to="goToImage"
  />
</template>

<script>
import Footer from "./Footer.vue";
import ImageArea from "./ImageArea.vue";
import BrowserManager from "../../services/browserManager";
import DataService from "../../services/DataService";
import MapContextMenu from "../MapContextMenu.vue";
import NavigationBar from "./NavigationBar.vue";
import UserInputManager from "../../services/UserInputManager";
import ObjectInfo from "./ObjectInfo.vue";
import LayersArea from "./LayersArea.vue";
import UsefulTools from "./UsefulTools.vue";
import MessagePresenter from "../MessagePresenter.vue";
import DrawingSettings from "./DrawingSettings.vue";
import Modal from "../Modal.vue";
export default {
  components: {
    Footer,
    ImageArea,
    MapContextMenu,
    NavigationBar,
    ObjectInfo,
    LayersArea,
    UsefulTools,
    MessagePresenter,
    DrawingSettings,
    Modal
  },
  data() {
    return {
      imageCount: 999,
      imageId: 0,
      userId: 0,
      layerId: 0,
      number: 1,
      jumpStep: 1,
      browserManager: null,
      dataService: null,
      datasetType: "",
      drawingsOn: false,
      neuralOn: false,

      imageName: "Нет изображения",
      missionGroupName: "Нет названия миссии",
      isEditable: false,
      editorEnabled: false,
      userName: "---",
      navBarActive: true,
      layers: [],
      tags: [],
      extraLayers: [],
      hasExtraLayers: false,
      extraLayersLoaded: true,
      isSuperviser: true,
      roles: [],
      debug : false,
      modalIsShown: false,
      modalMessage: ""
    };
  },
  mounted() {
    if(process.env.NODE_ENV == 'development'){
      this.debug = true;
    }
    this.browserManager = new BrowserManager();
    let winParams = this.browserManager.getUrlParams();
    this.dataService = new DataService();
    console.log("Serv version", this.$services.version);
    this.dataService.getPageInfo(
      winParams.image,
      winParams.layer,
      this.setPageInfo
    );
    this.userInputManager = new UserInputManager(
      this.$services.eventAggregator
    );
    this.$services.eventAggregator.on("toggledrawings", s=>this.onToggleDrawings(s));
    this.$services.eventAggregator.on("toggleneuralassist", s=>this.onToggleNeuralAssist(s));
    this.$services.eventAggregator.on("changeimage", s=>this.changeImage(s));
    this.$services.eventAggregator.on("fullscreen", ()=>this.toggleFullScreen());
    this.$services.eventAggregator.on("enableeditor", ()=>this.turnEditorOn());

    this.$services.mapManager.on("savenotes", ()=>this.saveNotes());
  },
  methods: {
    closeModal(){
      this.modalIsShown = false;
    },
    goToImage(num) {
      this.changeImage({number:num})
    },
    changeImage(data){
      const canChange = this.$services.mapManager.canSaveMarkup();
      if(!canChange){
        this.modalMessage = "Сначала нужно доработать со слоем нейросетевой разметки";
        this.modalIsShown = true;
        return;
      }
      this.$services.mapManager.fadeImage();
      this.save(true, data);
    },
    getNewImage(data){
      if(data.number){
        this.dataService.getImage(this.number, data.number - this.number, true, 0, this.setImage, this.onImageError);
        return;
      }
      if(data.step){
        this.dataService.getImage(this.number, data.step, true, 0, this.setImage, this.onImageError);
      }
    },
    setPageInfo(data) {
      if(this.debug){
        console.log("PageInfo", data);
      }
      data.datasetType = "";
      this.missionGroupName = data.missionGroupName;
      this.roles = data.roles;
      this.userId = data.userId;
      this.userName = data.username;
      this.imageCount = data.imageCount;
      this.isEditable = data.editable;
      window.appstate.isEditable = this.isEditable;
      this.editorEnabled = data.editorEnabled;
      this.$services.mapManager.init(data.datasetType);
      this.datasetType = data.datasetType;
      let winParams = this.browserManager.getUrlParams();
      this.dataService.getImage(winParams.image, 0, false, 0, this.setImage, this.onImageError);
      this.$services.eventAggregator.fire("editorenabled", this.editorEnabled);
    },
    onImageError(data){
      if(data.response.status == 404){
        this.$services.mapManager.returnImage();
        this.$messageManger.show("Больше нет изображений", '');
        return;
      }
      this.$messageManger.show("Ошибка загрузки изображения!", 'error');

    },
    setImage(data) {
      console.log("IMAGEInfo", data);
      this.$services.state.maxZoom =
        this.datasetType == "MapSlices" ? 20 : data.maxZoom;
      this.$services.state.mapSystem =
        this.datasetType == "MapSlices" ? "gps" : "simple";
      this.$services.mapManager.initImage(data);
      this.imageId = data.id;
      this.layerId = data.layerId;
      this.imageName = data.imageName;
      this.number = data.number;
      this.dataService.getMarkup(
        this.imageId,
        this.layerId,
        this.setMarkup,
        this.clearMarkup
      );
      this.loadNotes();
      this.browserManager.setUrl(this.imageId, this.layerId, true);
    },
    setMarkup(data, imageId) {
      if(this.debug){
        console.log("MARKUP DATA --------");
        console.log(data);
        console.log("------- END MARKUP DATA --------");
      }
      this.layerId = data.layerId;
      if (imageId !== data.imageId) {
        console.log("Wrong markup data");
        return;
      }
      this.$services.mapManager.initMarkup(data);
      this.browserManager.setUrl(this.imageId, this.layerId, false);
    },
    clearMarkup() {},
    save(shouldChangeImage,changeImageData){
      if(!this.isEditable){
        return;
      }
      const layers = this.$services.mapManager.getLayersToSave();
      const zeroChanges = !this.$services.mapManager.hasChanges();
      const dataToSave = {
        layers: layers,
        imageId: this.imageId,
        layerId: this.layerId,
        imageName: this.imageName,
        zeroChanges: zeroChanges,
        coordinateMultiplier: this.$services.mapManager.getMulitplier(),
        mapManager: this.$services.mapManager
      }
      this.dataService.saveData(dataToSave,
        (data, success, errorMessage, code) => {
          if(this.debug){
            console.log("Response", data);
          }
          //clearTimeout(savingTimeout);
          if (success) {
            if(!zeroChanges){
              this.$messageManger.show("Разметка сохранена!", 'success');
            }
            if(shouldChangeImage){
                this.getNewImage(changeImageData);
            }
            this.$services.mapManager.onSaveSuccess();
            //window.services.markupManager.clearEditedArray();
          } else {
            if(code === 403){
              this.$messageManger.show("Ошибка! Нет доступа к этой миссии!", 'error');
            }
            else{
              this.$messageManger.show("Ошибка сохранения разметки!", 'error');
            }
            console.log(errorMessage);
          }
        }
      );
    },
    saveOnButton() {
      this.save();
    },
    saveNotes(){
      this.dataService.saveNotes(
        this.imageId,
        this.$services.mapManager.getDrawings(),
        (data, success, errorMessage) => {
          if (success) {
            var nLink=window.location.origin+data.link;
            this.$messageManger.openPopup(nLink);
          } else {
            this.$messageManger.show("Ошибка сохранения заметки!", 'error');
            console.log(errorMessage);
          }
        }
        );
    },
    loadNotes(){
       const params = this.browserManager.getUrlParams();
       if(isNaN(params.note)){
        return;
      }
      this.dataService.getNotes(
        this.imageId, 
        params.note,
        (data, id) => {
          this.$services.mapManager.setNotes(data,id);
          this.$services.eventAggregator.fire("toggledrawings", true);
        }, 
        noteId => {
        console.log(`Note with id=${noteId} not found`);
      });
    },
    onToggleDrawings(show){
      this.drawingsOn = show;
      window.appstate.drawingsOn = show;
    },
    onToggleNeuralAssist(show){
      this.neuralOn = show;
    },
    turnEditorOn() {
      this.editorEnabled = true;
      this.isEditable = true;
      window.appstate.isEditable = true;
      this.$services.eventAggregator.fire("editorenabled", this.editorEnabled);
    },
    getExtraLayers(){},
    hideExtraLayers(){},
    toggleFullScreen(){
      this.browserManager.toggleFullScreen();
    }
  },
};
</script>

<style scoped>
.map-container {
  display: flex;
  height: calc(100vh - 2rem - 2rem);
}
.left-panel {
  display: flex;
  /* justify-content: space-around; */
  flex-direction: column;
  margin-left: 0.5em;
  /* flex-wrap: wrap; */
  /* align-items: flex-start; */
  min-width: 15em;
  max-width: 20em;
}
.left-panel-even-spaced {
  flex: 1 0 0;
}
.left-panel-min-spaced {
  flex: 0 1 0;
}
.scroll-list{
  overflow: auto;
}
</style>